module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Changer la méthode',
        standard: 'Standard',
        sameDayDelivery: 'Livraison le jour même',
        bopis: 'Achat en ligne et ramassage',
        checkAvailability: 'Vérifiez la disponibilité',
        confirm: 'Confirmer',
        cancel: 'Annuler',
        bopisUnavailable: 'L’achat en ligne et le ramassage ne sont pas disponibles pour le moment.',
        sameDayUnavailable: 'La livraison le jour même n’est pas disponible pour le moment.'
    };

    return resources[label];
};
